export default [
    {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/admin/dashboard',
        icon: 'cil-speedometer'
    },
    {
        _name: 'CSidebarNavItem',
        name: 'Langs',
        to: '/admin/langs',
        icon: 'cil-speedometer'
    }
];